import styled from 'styled-components';
import GeneralInfoHeader from './GeneralInfoHeader';
import Filter from './Filter';
import { useState } from 'react';
import GameShowRegisteredTable from './GameShowRegisteredTable';
import { QueryGameShowRegisterDto } from 'skychain-game-center-js/lib/dto/game-show.dto';
import { PageOptions } from 'skychain-game-center-js/lib/dto';

const Retangle = styled.div`
	height: 1px;
	width: 100%;
	background: linear-gradient(
		100.78deg,
		rgba(255, 255, 255, 0.116) 0.27%,
		rgba(255, 255, 255, 0.024) 102.68%
	);
	margin: 20px 0;
`;
const GameShow = () => {
	const [query, setQuery] = useState<QueryGameShowRegisterDto>();
	const [params, setParams] = useState<PageOptions>({
		page: 1,
		pageSize: 10,
	});
	return (
		<div style={{ position: 'relative' }}>
			<GeneralInfoHeader />
			<Retangle />
			<Filter
				setQuery={(query) => setQuery(query)}
				params={params}
				setParams={setParams}
			/>
			<GameShowRegisteredTable
				query={query}
				params={params}
				setParams={setParams}
			/>
		</div>
	);
};

export default GameShow;
